import React from 'react';
import { isEqual } from 'lodash';
import { WeaErrorPage, WeaTools,WeaLocaleProvider } from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
//引入元素组件
import { Element } from '../elements/';
class ElementIndie extends React.Component {
	constructor(props) {
        super(props);
        this.state = {
            config: null,
            eCss: '',
        }
        this.getElementData = this.getElementData.bind(this);
    }
    getElementData(params = {}){
        let url = params.elementtype == 'elementtemplate' ? '/api/portal/elementtemplate/preview':'/api/portal/elementindie/elementinfo';
        WeaTools.callApi(url, 'POST', params).then( data => {
            if(data.status === '2'){
                message.error(data.errormsg);
            }else{
                this.setState({
                    config: data.config,
                    eCss: data.eCss,
                });
            }
        });
    }
	componentWillMount(){
        this.getElementData(this.props.params)
	}
    componentWillReceiveProps(nextProps) {
        if(!isEqual(this.props.params, nextProps.params)){
            this.getElementData(nextProps.params);
        }
    }
    render() {
    	const { config, eCss } = this.state;
    	if(!config) return <div/>
    	let styleStr = "<style type='text/css'>" + eCss.replace(/\"/g, "") + "</style>";
        return <div>
        	<div dangerouslySetInnerHTML = {{__html:styleStr}}></div>
        	<Element ecId={`${this && this.props && this.props.ecId || ''}_Element@0z7zbb`} config={config}/>
        </div>
    }
}
class MyErrorHandler extends React.Component {
    render() {
        const hasErrorMsg = this.props.error && this.props.error !== "";
        return ( <WeaErrorPage ecId={`${this && this.props && this.props.ecId || ''}_WeaErrorPage@32e9j8`} msg = { hasErrorMsg ? this.props.error : getLabel(385218,"对不起，该页面异常，请联系管理员！") }/>
        );
    }
}
ElementIndie = WeaTools.tryCatch(React, MyErrorHandler, { error: "" })(ElementIndie);
export default ElementIndie;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/components/ElementIndie.js